import { RouterPaths } from "../routerPaths";
import { importPages } from "../lazyRoute";

const educationalSettingsRoutes = [
    {
        path: RouterPaths.ACADEMICYEAR,
        element: importPages.AcademicYear,
    },
    {
        path: RouterPaths.ACADEMICTERM,
        element: importPages.AcademicTerm,
    },
    {
        path: RouterPaths.STUDYYEARS,
        element: importPages.StudyYears,
    },
    {
        path: RouterPaths.TEACHINGTYPE,
        element: importPages.TeachingType,
    },
    {
        path: RouterPaths.SUBJECTCHECKTYPE,
        element: importPages.SubjectCheckType,
    },
    {
        path: RouterPaths.QUALIFICATION,
        element: importPages.Qualification,
    },
    {
        path: RouterPaths.EDUCATIONALDURATION,
        element: importPages.EducationalDuration,
    },
    {
        path: RouterPaths.EDUCATIONALSECTORS,
        element: importPages.EducationalSectors,
    },
    {
        path: RouterPaths.MODULARSUBJECT,
        element: importPages.ModularSubject,
    },
];
export default educationalSettingsRoutes;
